import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

const CancellationPolicyPage = () => (
  <div className="legal-page">
    <div className="legal-container">
      <Link to="/" className="legal-back-link">← Back to Home</Link>

      <div className="legal-header">
        <span className="legal-eyebrow">Legal</span>
        <h1 className="legal-title">Cancellation Policy</h1>
        <p className="legal-updated">Last updated: 18 March 2026</p>
      </div>

      <div className="legal-body">
        <p>
          This Cancellation Policy applies to all internship enrollments on the <strong>CodeHub</strong> platform
          operated by <strong>Batos IT</strong>.
        </p>

        <div className="legal-highlight">
          <strong>⚠️ No Cancellation After Payment:</strong> Once payment is successfully processed and an internship 
          enrollment is confirmed, the enrollment <strong>cannot be cancelled</strong>.
        </div>

        <h2>1. Before Payment</h2>
        <p>
          You may browse all available projects, review the internship structure, and explore the platform freely
          before enrolling. There is no obligation until you complete a payment.
        </p>
        <ul>
          <li>No charges are applied until you confirm enrollment and complete payment.</li>
          <li>You can take as much time as needed to review the terms before paying.</li>
          <li>Contact support for any pre-enrollment questions.</li>
        </ul>

        <h2>2. After Payment</h2>
        <p>Once your payment is successfully processed:</p>
        <ul>
          <li>A project is immediately assigned to you.</li>
          <li>Your enrollment is confirmed and <strong>cannot be cancelled</strong>.</li>
          <li>You will have access to project guidelines and submission tools.</li>
          <li>Mentor resources are allocated for your review cycle.</li>
        </ul>

        <h2>3. Project Changes</h2>
        <p>
          After enrollment, you <strong>cannot switch</strong> to a different project or category.
          The project assigned at the time of enrollment is final.
        </p>

        <div className="legal-info">
          <strong>💡 Choose Wisely:</strong> Please review the project category and difficulty level carefully before 
          enrolling. Each category and project is clearly described on the platform to help you make an informed choice.
        </div>

        <h2>4. Internship Completion Timeline</h2>
        <ul>
          <li>You have <strong>30 days</strong> from the date of enrollment to complete and submit your project.</li>
          <li>If you do not submit within 30 days, your enrollment may be marked as expired.</li>
          <li>Expired enrollments are <strong>not eligible</strong> for refunds or extensions.</li>
        </ul>

        <h2>5. Account Deletion</h2>
        <p>
          If you request account deletion while you have an active enrollment:
        </p>
        <ul>
          <li>Your enrollment will be forfeited.</li>
          <li>No refund will be issued for the forfeited enrollment.</li>
          <li>Previously earned certificates will remain verifiable via their certificate URL.</li>
        </ul>

        <h2>6. Platform Discontinuation</h2>
        <p>
          In the unlikely event that Batos IT discontinues the CodeHub platform:
        </p>
        <ul>
          <li>All users with active enrollments will be notified via email.</li>
          <li>Reasonable time will be provided to complete in-progress projects.</li>
          <li>Certificates already issued will remain accessible for verification.</li>
        </ul>

        <h2>7. Contact Us</h2>
        <p>For any cancellation-related queries:</p>

        <div className="legal-contact">
          <h3>Batos IT</h3>
          <p>
            Sterling Towers, Level 1, 2 & 3, Pan Card Club Road, Baner, Pune 411045<br />
            Email: <a href="mailto:connect@batosit.com">connect@batosit.com</a><br />
            Website: <a href="https://codeninja.batosit.com">codeninja.batosit.com</a>
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default CancellationPolicyPage;
